<template>

    <div class="w-full">
        <h4 class="mb-3">Clients</h4>

        <vs-button color="success" icon-pack="feather" icon="icon-plus-circle" class="mb-3" @click="addClientPrompt = true">Add</vs-button>

        <vx-card id="clientsDiv"  class="vs-con-loading__container">

            <vs-table ref="table" @selected="openClient" :data="tableData" class="mt-3" pagination search :maxItems="itemsPerPage">
                <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                    <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4" v-if="tableData.length > 0">
                        <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ tableItems - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : tableItems }} of {{ tableItems }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>

                        <vs-dropdown-menu>

                            <vs-dropdown-item @click="itemsPerPage=10">
                                <span>10</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=20">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=50">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=100">
                                <span>100</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=250">
                                <span>250</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=500">
                                <span>500</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="itemsPerPage=1000">
                                <span>1000</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>

                <template slot="thead">
                    <vs-th sort-key="name">Name</vs-th>
                    <vs-th sort-key="username">Username</vs-th>
                    <vs-th sort-key="email">Email</vs-th>
                    <vs-th sort-key="credits">Credits</vs-th>
                    <vs-th sort-key="connections">Connections</vs-th>
                    <vs-th sort-key="STB Pin">STB Pin</vs-th>
                    <vs-th sort-key="enabled">Status</vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                        <vs-td :data="data[index].name">
                          {{ data[index].name }}
                        </vs-td>

                        <vs-td :data="data[index].username">
                            {{ data[index].username }}
                        </vs-td>

                        <vs-td :data="data[index].email">
                            {{ data[index].email }}
                        </vs-td>

                        <vs-td :data="data[index].credits">
                            {{ data[index].credits }}
                        </vs-td>

                        <vs-td :data="data[index].connections">
                            {{ data[index].connections }}
                        </vs-td>

                        <vs-td :data="data[index].stb_access_pin_formatted">
                          {{ data[index].stb_access_pin_formatted }}
                        </vs-td>

                        <vs-td :data="data[index].enabled">
                            <vs-chip color="success" v-if="data[index].enabled">Enabled</vs-chip>
                            <vs-chip color="danger" v-else>Disabled</vs-chip>
                        </vs-td>

                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>

        <vs-popup title="Add client" :active.sync="addClientPrompt">
            <div id="addClientDiv" class="vs-con-loading__container" >
                <p class="mt-6">Name</p>
                <vs-input v-model="addObject['name']" class="w-full"></vs-input>
                <p class="mt-6">Email</p>
                <vs-input v-model="addObject['email']" class="w-full"></vs-input>
                <p class="mt-6">Username</p>
                <vs-input v-model="addObject['username']" class="w-full"></vs-input>
                <vs-divider/>
                <vs-button color="success" class="mt-6; mr-1" @click="addClient">Add</vs-button>
            </div>
        </vs-popup>

    </div>

</template>
<script>

    export default {

        data(){
            return {

                itemsPerPage: 20,
                isMounted: false,

                clients: [],

                addClientPrompt: false,

                addObject: {

                },

            }
        },
        methods: {

            loadData(){

                this.$vs.loading({
                    container: "#clientsDiv",
                    type: 'corners',
                    scale: 0.7
                });

                const thisIns = this;
                const loadPromise = this.$http.get('/api/reseller/v1/client/');
                loadPromise.then(function (response) {
                    thisIns.clients = response.data;
                }).catch(function (error) {
                    thisIns.$printError(error.response.data);
                }).finally(function () {
                    thisIns.$vs.loading.close("#clientsDiv > .con-vs-loading");
                });

            },
            addClient(){

                this.$vs.loading({
                    container: "#addClientDiv",
                    type: 'corners',
                    scale: 0.7
                });

                const thisIns = this;

                const addPromise = this.$http.post('/api/reseller/v1/client/', {
                    name: this.addObject.name,
                    email: this.addObject.email,
                    username: this.addObject.username,
                });

                addPromise.then(function (response) {
                    thisIns.addClientPrompt = false;
                    thisIns.$printSuccess("Client added");
                    thisIns.$nextTick(() => {
                        thisIns.$router.push("/client/" + response.data);
                    });

                }).catch(function (error) {
                    thisIns.$printError(error.response.data);
                }).finally(function () {
                    thisIns.$vs.loading.close("#addClientDiv > .con-vs-loading");
                })

            },
            openClient(tr){
                this.$router.push("/client/" + tr.id);
            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
            tableItems(){
                if(this.isMounted) {
                    return this.$refs.table.queriedResults.length
                }
                return 0
            },
            tableData() {
                return this.clients;
            }
        },
        mounted() {
            this.isMounted = true;
            this.loadData();
        }

    }

</script>
